/* =========================================================================
   QUÉ NEGOCIO SE ESTÁ ADMINISTRANDO

   Un tendero puede tener más de un local. La app móvil se queda con el
   primero y nunca deja llegar al segundo; acá se puede cambiar, y ese cambio
   tiene que llegarle a TODAS las peticiones.

   Vive en un módulo y no en el contexto de React porque quien lo necesita
   primero es el interceptor de axios, que no está dentro del árbol de
   componentes. El contexto lo refleja para que la interfaz reaccione; la
   fuente es esta.

   Se guarda en `localStorage` para que recargar no devuelva al primer local:
   quien administra dos tiendas trabaja un rato en cada una, y volver a
   elegirla en cada recarga es de las cosas que hacen abandonar un panel.
   ======================================================================== */

const CLAVE = "vpy.negocio.activo";

let enMemoria = null;

/**
 * Respaldo en memoria por si el almacenamiento está bloqueado (modo privado,
 * cookies de terceros desactivadas). Sin él, el selector se vería cambiar y la
 * petición seguiría yendo al local anterior — que es peor que no poder cambiar.
 */
export const negocioActivo = {
  get() {
    if (enMemoria !== null) return enMemoria;

    try {
      const guardado = localStorage.getItem(CLAVE);
      enMemoria = guardado ? Number(guardado) : null;
    } catch {
      enMemoria = null;
    }

    return enMemoria;
  },

  set(id) {
    enMemoria = id ? Number(id) : null;

    try {
      if (enMemoria) localStorage.setItem(CLAVE, String(enMemoria));
      else localStorage.removeItem(CLAVE);
    } catch {
      /* queda solo en memoria: dura lo que la pestaña */
    }
  },
};
